export default {
  observability: {
    expectedApiErrors: [],
    mutedApiErrors: [],
  },
};
